import React, { useState, useRef, useEffect } from 'react';
import { Component } from 'react';
import md5 from 'md5';
import environment from '../environment';
const UserContext = React.createContext(false, null, () => {});



export class AppProvider extends Component {


    constructor(props) 
    {
        super(props);
        this.state = {

            unique_session_id: "",
            chatStarted: false,
            agent_is_typing: false,
            listofMessages: [],
            socket: {},
            owner_token: "",
            numberChats: 0,
            showChatWindow: false,
            currentPageUrl: "",
            os: "",
            customerData: {currentPageUrl: "n/a", os: "n/a", refer: "n/a", title: "n/a", device: "n/a"},
            owner_online: false,

            team: [],
  teamLoading: false,
            
            myStrings: {
              textInWidgetChatNotStartedOnline: "We are online, so if you have a question get in touch with us and lets chat now.",
              textInWidgetChatNotStarted: "Our agents are not available right now, you can still send us a message. We will get back to you by email.",
                leaveMessage: "Leave a message",
                thankYouTextAfterMessage: "Thank you for contacting us. We will get back to you as soon as possible."
            }
         }
    }  



    fetchTeam = async (ownerUuid) => 
    {
        if (!ownerUuid) return;
        const cacheKey = `super_ecd_team_${ownerUuid}`;
        const ttlKey = `${cacheKey}_ttl`;
        const now = Date.now();

        try {
          this.setState({ teamLoading: true });

          // cache hit?
          const cached = localStorage.getItem(cacheKey);
          const ttl = parseInt(localStorage.getItem(ttlKey) || '0', 10);
          if (cached && ttl > now) {
            this.setState({ team: JSON.parse(cached), teamLoading: false });
            return;
          }

          const res = await fetch(`https://api10.easychatdesk.com/public/team/${encodeURIComponent(ownerUuid)}`);
          if (!res.ok) throw new Error(`Team fetch failed (${res.status})`);

          const { users } = await res.json(); // [{ name, avatar_url }]
          this.setState({ team: users, teamLoading: false });

          localStorage.setItem(cacheKey, JSON.stringify(users));
          localStorage.setItem(ttlKey, String(now + 10 * 60 * 1000)); // 10 min TTL
        } catch (e) {
          console.error('Team load error:', e);
          this.setState({ teamLoading: false });
        }
     };


  getUserDataAndSendLogin = async (socket) => {
      const myData = await fetch('https://ipapi.co/json/')
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          return null;
        })
        .then(data => {
          // data; // Return the country name
          /* asn, city, continent_code, country, country_area, country_calling_code, country_capital, 
          country_code, country_code_iso3, country_name, country_population, country_tld, currency, 
          currency_name, in_eu, ip, languages, latitude, longitude, network, org, postal, region, 
          region_code, timezone, utc_offset, version */

          //console.log(data);

          return data;

        })
        .catch(error => {
          console.error('Error:', error);
          return null; // Handle errors or return null if the country could not be determined
        });

        if(myData == null)
        {
          //http://ip-api.com/json/?fields=61439
          //https://api.country.is/

          var myData2 = await fetch('http://ip-api.com/json/?fields=61439')
            .then(response => {
              if (response.ok) {
                return response.json();
              }
              return null;
            })
            .then(data => {
              return data;

            })
            .catch(error => {
              console.error('Error:', error);
              return null; 
            });

            if(myData2 != null)
            {
              myData2.country = myData2.countryCode
              myData2.country_code = myData2.countryCode
              myData2.country_name = myData2.country
              myData2.region_name = myData2.regionName
            }
            
            this.sendGreetingLogin(socket, myData2)
        }
        else this.sendGreetingLogin(socket, myData)

    }



    setAgentTyping = (agent_is_typing) =>{

      this.setState({ agent_is_typing: agent_is_typing });
  
     }  

    

    setUniqueSessionID = (unique_session_id) =>{

     this.setState({ unique_session_id: unique_session_id });
 
    }       
 
    setMyStrings = (myStrings) =>{
      this.setState({ ...this.state, myStrings: myStrings });  
    }
    

    setownerstatus = (owner_online) =>{
      this.setState({ ...this.state, owner_online: owner_online });  
    }

    setcustdata = (customerData) =>{
      this.setState({ ...this.state, customerData: customerData });  
    }


    closeChat = () =>{

        const item = {action: 'customer_ends_chat', payload: {owner_token: this.state.owner_token,
        customer_id: this.getCookie('customer_id_ex') }}
        this.state.socket.send(JSON.stringify(item))

        this.setChatEnded()

    }


    //**************************** en fetch data function *****************************************/

    
    async fetchData(data) {   
          
          if(data != undefined)
          {



            if(data[data.length-1] != undefined)
            {
                const datemadeLastDate = data[data.length-1].datemade;
                const currentTimestamp = new Date().toISOString();

                //console.log("datemadeLastDate", datemadeLastDate)
               // console.log("currentTimestamp", currentTimestamp)

                const date1 = new Date(datemadeLastDate);
                const date2 = new Date(currentTimestamp);

                const diffInMilliseconds = date2.getTime() - date1.getTime();
                const diffInSeconds = diffInMilliseconds / 1000;


               // console.log("FDiff data...", diffInSeconds);

                if(diffInSeconds < 120)
                {
                      window.parent.postMessage({ action: 'maximizeFullChatWidget', newStyle: '' }, '*');
                      this.setChatStarted();
            }
          }
        }

  }

  //**************************** en fetch data function *****************************************/




    updatenumberofchats = () =>
    {
      

    }


    

    setOwnerToken = (owner_token) =>{
      this.setState({ ...this.state, owner_token: owner_token });  
    }


    setListOfMessages = (newMessages) => {

     this.setState({ listofMessages: newMessages });
    };



    //-----------------------------------------------

    getCookie(cName) {
      const saved = localStorage.getItem(cName);
      return saved;
    }


    //-----------------------------------------------

    setcookie(name, value)
    {
      localStorage.setItem(name, value);
    }


    uniqueId = (length=16) => 
    {
      return Math.random().toString(36).substr(2, 12)
    }

    //-----------------------------------------------

    generatePayLoad()
    {
        var object = {}
        object.type = "customer";
        const customer_id = this.getCookie('customer_id_ex')
        object.customer_id = customer_id;

        return object;
    }

   
    generateToken2()
    {
    
      return md5(this.uniqueId())
    }


    sendGreetingLogin(socket, datatoMerge)
    {
      const urlParams = new URLSearchParams(window.location.search);
      let license = urlParams.get('license');
      let uniqueID = this.generateToken2();

        var object = {}
        object.action             = "login-new";
        object.request_id         = this.uniqueId()

        object.customer_page      = this.state.customerData.currentPageUrl
        object.os                 = this.state.customerData.os
        object.refer              = this.state.customerData.refer
        object.title              = this.state.customerData.title
        object.page_title         = this.state.customerData.title
        object.device             = this.state.customerData.device
        object.token              = this.generateToken2();
        object.owner_token        = license;
        object.payload            = this.generatePayLoad();
        object.unique_session_id = this.state.unique_session_id


        const emailTmp = localStorage.getItem("yourEmail")
        const nameTmp = localStorage.getItem("yourName")

        if(emailTmp!=undefined)
          object.email        = emailTmp;


        if(emailTmp!=undefined)
          object.name        = nameTmp; 


        if (datatoMerge) {
          Object.assign(object, datatoMerge);
        }


        if (socket.readyState === WebSocket.OPEN) {
           
          socket.send(JSON.stringify(object));
        }
    }
    

    //-----------------------------------------------

    setSocket = (sock) =>{
      this.setState({ ...this.state, socket: sock });  
    }


    handleMessage = (event) => {

 

      if(event.data.title != undefined)
      {
        const receivedCurrentPageUrl = event.data.currentURLECD
        const os = event.data.os
        const refer = event.data.refer
        const title = event.data.title
 

        const custdata = {currentPageUrl: receivedCurrentPageUrl, os: os, refer: refer, title: title,
          device: event.data.device
        }

        this.setcustdata(custdata)

        this.getUserDataAndSendLogin(this.state.socket);


      }

      if(event.data.maximixeME != undefined)
      {
        document.body.classList.remove('minimized');
 
      }    
      

    }


    getMyCookie()
    {
      return this.getCookie('customer_id_ex');
    }


        componentDidMount() 
        {

          

          window.addEventListener('message', this.handleMessage);
            


            const serverURL = environment.serverURL;
            var socket = new WebSocket(serverURL)

            const heartBeat = 
            {
              action: "heartbeat",
              payload: {
                type: "customer",
                customer_id: "x1"
              } }


            socket.onopen = (event) => {
            //  console.log("Opening socket....")
              
              //this.getUserDataAndSendLogin(socket);
            }


            //----- on message ---------------------------

            socket.onmessage = (event) => {

              const data = JSON.parse(event.data);
              const cookieID = data.cookieID;

              const sound1 = new Audio('https://cdn.easychatdesk.com/assets/ping1.mp3');

              const playSoundNewChat = () => {
                
                
                sound1.play()
                .then(() => {
                   // console.log("Audio played successfully");
                })
                .catch(error => {
                   // console.error("Error occurred during audio playback:", error);
                });

                };


              if(data.type == "login")
              {
                  this.setOwnerToken(data.payload.owner_token)
                  this.fetchTeam(data.payload.owner_token);


                  const cookie = this.getCookie('customer_id_ex');
                 // console.log("Local cookie: " + cookie)
                  if(cookie == undefined)
                  {
                    this.setcookie('customer_id_ex', data.payload.customer_id)

                    const mm = this.getCookie('customer_id_ex');
                   // console.log("Cookie set: " + mm)
                    //this.fetchData(data.payload.customer_id);
                  }
                  else
                  {
                    //this.fetchData(cookie);
                  }

              }
              else if(data.type == "update_chat_widget_settings")
              {
                const providedJSONINCALL = data.payload[0]
                const is_user_online = data.is_user_online
               
                const jsonPayloadProvided = providedJSONINCALL.json_options
 
                const colorMinimized = jsonPayloadProvided.colorBackgroundMinimized;
                const colorMinimizedText = jsonPayloadProvided.colorTextMinimized

               // console.log(jsonPayloadProvided)

                let minimizedTextMessage = jsonPayloadProvided.minimizedChatTextOffline
                let usrOnline = "no";

                if(is_user_online == "yes")
                {
                  usrOnline = "yes";
                  this.setownerstatus(true)
                  minimizedTextMessage = jsonPayloadProvided.minimizedChatTextOnline
                } 
                window.parent.postMessage({ action: 'setNewColors', 
                
                newStyle: {
                  
                  dataObjectWithThings: jsonPayloadProvided,                  
                  textColor: colorMinimizedText,
                  isUserOnline: usrOnline,
                        backgroundColor: colorMinimized,
                        minimizedTextMessage: minimizedTextMessage,
                        minimizedTextMessage: minimizedTextMessage

                  } }, '*');

              }

              else if(data.type == "agent_ending_chat")
               {

                 this.setChatEnded();

               }
              
              else if(data.type == "agent_typing_a_message")
              {
                //console.log("agent is currently typing....")
                   this.setAgentTyping(true)

              }

              else if(data.type == "update_chats")
              {
                  

                  const reversedArray = [...data.payload].reverse();
                  //this.fetchData(reversedArray)

                  var arr1 = this.state.listofMessages

                  if(reversedArray.length > 0)
                  for(let i=0; i<reversedArray.length; i++)
                  {
                    arr1.push({
                      message: reversedArray[i].message,
                      sender: reversedArray[i].who_sent_message,
                      datemade: reversedArray[i].datemade,
                      avatar_url: reversedArray[i].avatar_url
                    });
                  }

              

                  this.setListOfMessages(arr1);


              }
              else if(data.type == "chat_session")
              {
                  const payload = data.payload;

                  if(payload == "yes")
                  {
                      window.parent.postMessage({ action: 'maximizeFullChatWidget', newStyle: '' }, '*');
                      this.setChatStarted();
                  }
              }
              // agent is sending a message, initiating the chat
              else if(data.type == "initiate_start_chat")
              {
                  const payload = data.payload;
                  const message = payload.message;
                  const agent_uuid = payload.agent_uuid;
                  const avatar_url = payload.avatar_url;

                  var arr1 = this.state.listofMessages
                  arr1.push({
                    message: message,
                    sender: "agent",
                    avatar_url: avatar_url
                  })
                  
                  playSoundNewChat();
                  window.parent.postMessage({ action: 'maximizeFullChatWidget', newStyle: '' }, '*');


                  
                  this.setListOfMessages(arr1)
                  
                  this.setChatStartedAndOwnerOnline();

              }
              else if(data.type == "owner_has_updated_availability")
              {
                const payload = data.payload;
                const accept_chats = payload.accept_chats


                //let minimizedTextMessage = jsonPayloadProvided.minimizedChatTextOffline
                if(accept_chats == "no")
                {
                    this.setownerstatus(false)
                } 
                else
                {
                  //minimizedTextMessage = jsonPayloadProvided.minimizedChatTextOnline
                  this.setownerstatus(true)
                }

                //console.log("Owner has updated availability: " + accept_chats)

                window.parent.postMessage({ action: 'ownerHasUpdatedAvailability',                 
                data: {
                        accept_chats: accept_chats
                  } }, '*'); 

              }              
              else if(data.type == "received_from_other_sources")
              {
                const payload = data.payload;
                const message = payload.message;
                const datemade = payload.datemade;
                const unique  = payload.unique;
                var addIt = true;                   


                var arr1 = this.state.listofMessages


                      arr1.push({
                        message: message,
                        sender: "customer",
                        datemade: datemade,
                        unique: payload.unique
                      })

                      this.setListOfMessages(arr1)
             

              }              
              else if(data.type == "received_message_from_agent")
              {
                const payload = data.payload;
                const message = payload.message;
                const avatar_url = payload.avatar_url;

                this.setAgentTyping(false)
            
                playSoundNewChat();
                window.parent.postMessage({ action: 'maximizeFullChatWidget', newStyle: '' }, '*');
               // console.log("Agent sent a message: " + message)
                
                var arr1 = this.state.listofMessages
                arr1.push({
                  message: message,
                  sender: "agent",
                  avatar_url: avatar_url
                })

                this.setListOfMessages(arr1)
              }

            }

            //------

            setInterval(() => {

              if(socket.readyState !== WebSocket.CLOSED)
              {
               // console.log("test every 45 seconds")
                socket.send(JSON.stringify(heartBeat));
              }
              else
              {
                const serverURL = environment.serverURL;
                socket = new WebSocket(serverURL)
                this.setSocket(socket)

              }
  
           
            }, 90000);


            //----------

            this.setSocket(socket)
            this.setUniqueSessionID(this.generateToken2())

        }


               setChatStartedAndOwnerOnline = () =>{
          this.setState({ ...this.state, chatStarted: true, owner_online: true, agent_is_typing: false });  
      }


        setChatStarted = () =>{
          this.setState({ ...this.state, chatStarted: true });  
      }

      setChatEnded = () =>{
        this.setState({ ...this.state, chatStarted: false });  
    }


      render() {

        return(<UserContext.Provider value={{

          updatenumberofchats: this.updatenumberofchats,
          numberChats: this.state.numberChats,
          listofMessages: this.state.listofMessages,
          chatStarted: this.state.chatStarted, 
          setChatStarted: this.setChatStarted, 
          socket: this.state.socket,
          agent_is_typing: this.state.agent_is_typing,
          setListOfMessages: this.setListOfMessages, 
          getCookie: this.getCookie,
          getMyCookie: this.getMyCookie,
          showChatWindow: this.state.showChatWindow,
          owner_token: this.state.owner_token,
          setcurrentPageUrl: this.setcurrentPageUrl,
          currentPageUrl: this.state.currentPageUrl,
          closeChat: this.closeChat,
          customerData: this.state.customerData,
          textInWidgetChatNotStarted: this.state.textInWidgetChatNotStarted,
          owner_online: this.state.owner_online,
          myStrings: this.state.myStrings,
          unique_session_id: this.state.unique_session_id,


          team: this.state.team,
  teamLoading: this.state.teamLoading,
  refreshTeam: () => this.fetchTeam(this.state.owner_token),
        
        
        }}
          
          
          >{
        this.props.children
        }</UserContext.Provider>)

      }



    }


    export default UserContext